export const BREADCRUMBS = [
  { key: 'nsaa', value: 'NSAA' },
  { key: 'subcription center', value: 'Join Our Mailing List' },
];
